import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Link } from 'gatsby';
import Layout from '../../../components/layout';
import { dates } from '../../../components/dates';
import { LinkResolution } from '../../../components/resolution';
import { MinutesHeader, minutes_type, minutes_status } from '../../../components/minutes';
export const resolutions = [];
export const date = '2020-12-09T18:30-08:00';
export const remote = true;
export const status = minutes_status.approved;
export const type = minutes_type.reorg;
export const m = {
  date,
  remote,
  status,
  type
};
export const {
  prev_path
} = dates(date);
export const _frontmatter = {};
const layoutProps = {
  resolutions,
  date,
  m,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <Layout mdxType="Layout">
      <MinutesHeader m={m} mdxType="MinutesHeader" />
      <dl className="agenda">
	<dt>6:30</dt><dd>Registration</dd>
	<dt>7:00</dt><dd>Call to Order by Temporary Chair</dd>
	<dd><Link to="/pledge-of-allegiance" className="link" mdxType="Link">Pledge of Allegiance</Link></dd>
	<dd>Credential Committee Report</dd>
	<dd>Adoption of the Agenda and Rules (PCO only vote)</dd>
	<dd>Discussion of Reorganization Procedures</dd>
	<dd>Overview of Election Process</dd>
	<dd>Election of Initial Officers (PCO only vote)
		<ul>
		<li>Chair</li>
		<li>1<sup>st</sup> Vice Chair</li>
		<li>2<sup>nd</sup> Vice Chair</li>
		<li>Representative to the KCDCC Executive Board (1)</li>
		<li>Representative to the KCDCC Executive Board (2)</li>
		<li>Alternate to the KCDCC Executive Board (1)</li>
		<li>Alternate to the KCDCC Executive Board (2)</li>
		<li>Representative to the SCDCC Executive Board (1)</li>
		<li>Representative to the SCDCC Executive Board (2)</li>
		<li>Alternate to the SCDCC Executive Board (1)</li>
		<li>Alternate to the SCDCC Executive Board (2)</li>
		<li>State Committee member (1)</li>
		<li>State Committee member (2)</li>
		</ul>
	</dd>
	<dd>Election of Additional Officers
	<ul>
		<li>Treasurer</li>
		<li>Secretary</li>
	</ul>
	</dd>
	<dd>Ratification of Appointed Officers</dd>
	<dd>Old Business</dd>
	<dd>New Business</dd>
	<dd>PCO Appointments</dd>
	<dd>Announcement of next meeting date</dd>
	<dd>Good of the Order</dd>
	<dd>Adjournment</dd>
      </dl>
      <ul className="menu">
	<li><a href="https://secure.actblue.com/donate/32membership">
	Join or renew your membership dues for 2021.
	</a></li>
	<li><a href="https://us02web.zoom.us/meeting/register/tZ0pcu2hrToiGNaIESrnmZgoeL9aEqXIehPr">Register in advance for this meeting.</a></li>
      </ul>
      <p>{`After registering, you will receive a confirmation email containing information about joining the meeting.`}</p>
      <h1>{`Proposed Bylaws Amendment`}</h1>
      <a id="amendment" /><pre className="article legal">
        <h2>{`Section 3.2 General Members`}</h2>
        <h3>{`3.2.A`}</h3>
        <p>{`Any other person registered to vote in the 32nd Legislative District, who publicly identifies as a Democrat, may become a General Member of this organization upon payment of dues, or upon waiver of dues by the District Chair.`}</p>
        <h3>{`3.2.B`}</h3>
        <p>{`General Members shall be eligible to vote and run for office as specified by these bylaws 28 days after payment or waiver of dues; provided, however, that those who were members during the previous year shall be eligible to vote immediately upon payment of dues `}<strike>{`during the first quarter of the current year`}</strike>{`.`}</p>
        <h3>{`3.2.C`}</h3>
        <p>{`All elected officials serving in the Washington State Legislature, or the United States Congress, or in any statewide office in Washington State, who reside in the 32nd Legislative District and identify as Democrats, shall be General Members of this organization.`}</p>
        <h2>{`Section 3.4 Dues`}</h2>
        <p>{`Annual dues shall `}<strike>{`cover a calendar year`}</strike>{` `}<u>{`be set by the membership`}</u>{` and shall include a limited-income dues structure to be prescribed by a Standing Rule.`}</p>
        <h1>{`Article IV – Officers, Executive Board, and Committees`}</h1>
        <h2>{`Section 4.6 Committees`}</h2>
        <h3>{`4.6.A`}</h3>
        <p>{`The Chair shall serve as an ex officio voting member of all committees, including the following Standing Committees:`}</p>
        <ul>
          <li parentName="ul">{`Membership`}</li>
          <li parentName="ul">{`Programs`}</li>
          <li parentName="ul">{`Legislative Action`}</li>
          <li parentName="ul"><strike>District Campaigns</strike> <u>Endorsements</u></li>
          <li parentName="ul">{`Communications`}</li>
          <li parentName="ul">{`Community Service`}</li>
          <li parentName="ul">{`Fundraising`}</li>
          <li parentName="ul">{`Diversity & Inclusion`}</li>
          <li parentName="ul">{`Young Democrats`}</li>
          <li parentName="ul">{`Resolutions`}</li>
          <li parentName="ul">{`Technology`}</li>
        </ul>
        <h1>{`Article XIV – Parliamentary Authority`}</h1>
        <p>{`The affairs and meetings of this organization shall, except as specifically provided by its Bylaws or Standing Rules, or by bylaws or rules of the KCDCC or SCDCC, be governed by the `}<strike>{`latest`}</strike>{` `}<u>{`12th`}</u>{` edition of Robert’s Rules of Order, Newly Revised.`}</p>
      </pre>
      <section>
        <h1>Reorganization Meetings</h1>
        <p>The Bylaws of the Washington State Democratic Party require all County and Legislative District Parties to reorganize in the December or January following an even-year general election. <strong>At a Reorganization Meeting, Precinct Committee Officers elected during the most recent primary elect a new Chair, new Vice Chairs, and new State Committee members for the organization</strong>. Other officers may be elected and additional party business may be conducted. <strong>Newly elected State Committee members will meet in the last weekend of January to reorganize the State Party.</strong></p>
        <p>If you are an elected PCO, you are encouraged to attend both your County and Legislative District reorganization meetings. If you have questions about how your reorganization meeting will be run, read our <a href="http://www.wa-democrats.org/page/reorganization-faq">Reorganization FAQ</a>.</p>
        <ul>
          <li parentName="ul">{`King County Reorganization Meeting: Saturday, December 5th, 2020`}</li>
          <li parentName="ul">{`Snohomish County Reorganization Meeting: Saturday, December 12th, 2020`}</li>
          <li parentName="ul">{`Washington State Democrats Reorganization Meeting: January, 2021`}</li>
        </ul>
        <ul className="menu">
          <li><Link to="/contacts" mdxType="Link">32nd LD Officers and Contacts</Link></li>
          <li><Link to="/platform/2018" mdxType="Link">32nd LD 2018 Platform</Link></li>
          <li><Link to="/bylaws" mdxType="Link">32nd LD 2018 Bylaws and Standing Rules</Link></li>
        </ul>
      </section>
      <hr />
      <p>{`Below are generic proposed Reorganization Rules. The 32nd Bylaws and Rules Committee will be meeting this month to review the 32nd Bylaws, Rules and Agenda for updates and/or additions. If you are interested in participating on the Committee, please email `}<a href="mailto:carin.chase@32democrats.org">{`Carin Chase`}</a>{`.`}</p>
      <h2>{`Eligible Voters`}</h2>
      <p>{`At the reorganization meeting only Precinct Committee Officers (PCOs) elected during the primary election on August 4, 2020 (including any PCOs who were the only candidate to file in their precinct, and were elected without appearing on a ballot) are allowed to vote for the Chair, 1st Vice Chair, State Committeewoman, State Committeeman, and any representative the central committee is authorized to send to other Party organizations, as well as on the adoption or amendment of bylaws.`}</p>
      <p>{`Eligible voters in elections for other leadership positions and issues are determined by local bylaws (or the rules passed for the reorganization meeting, if local bylaws do not specify.) Proxies are not permitted at reorganization meetings.`}</p>
      <h2>{`Reorganization Rules and Procedures`}</h2>
      <ol>
        <li parentName="ol">{`Sign-in is required at check-in.`}</li>
        <li parentName="ol">{`Eligible voters shall be limited to PCOs elected during the August 4, 2020 Primary (including any PCOs who were elected without appearing on a ballot because they were the only person to file in their precincts).`}<ul parentName="li">
            <li parentName="ul">{`Eligible voters will be issued ballots.`}</li>
            <li parentName="ul">{`A 50% + 1 majority vote of members present and voting is necessary to approve any vote unless otherwise noted.`}</li>
          </ul></li>
        <li parentName="ol">{`The meeting shall be called to order by the Temporary Chair.`}<ul parentName="li">
            <li parentName="ul">{`The Temporary Chair shall preside until the election of the new Chair.`}</li>
          </ul></li>
        <li parentName="ol">{`Election of officers shall proceed in the order as provided in the Bylaws and Standing Rules (as shown in the agenda).`}</li>
      </ol>
      <p>{`Process for nominating and electing all positions shall be as described in `}<a parentName="p" {...{
          "href": "/rules#S1"
        }}>{`Standing Rule 1: Election Procedures`}</a>{`.`}</p>
      <p>{`Eligibility of officers as described in `}<a parentName="p" {...{
          "href": "/bylaws#S4"
        }}>{`Bylaws Article 4 – Officers, Executive Board, and Committees`}</a>{`.`}</p>
      <hr />
      <h1>MINUTES</h1>
      <p><b>6:30 PM  </b><span style={{
          "fontWeight": "400"
        }}>Sign In</span></p>
      <p><b>7:00  Call to Order by Hillary Moralez, Snohomish County Chair, who will be serving as Temporary ReOrg Chair</b><span style={{
          "fontWeight": "400"
        }}>. Julie Anne Kempf, 46th LD Chair, will serve as Temporary ReOrg Parliamentarian and will help with the tally. </span></p>
      <p><b>7:02  Land Acknowledgment</b><span style={{
          "fontWeight": "400"
        }}> by Cathy Baylor, Chair<br />
        </span><span style={{
          "fontWeight": "400"
        }}>Federation of Democratic Women, Salish Sea Chapter</span></p>
      <p><b>7:04  Pledge of Allegiance</b></p>
      <p><b>7:06  Credentials Report</b><span style={{
          "fontWeight": "400"
        }}>: 55 eligible PCOs</span></p>
      <p><b>7:07  Elected Officials Attending<br />
        </b><span style={{
          "fontWeight": "400"
        }}>Representatives Cindy Ryu and Lauren Davis; Edmonds City Council President Adrienne Fraley-Monillas; Shoreline Deputy Mayor Keith Scully; Shoreline Council Members Doris McConnell and Chris Roberts; Edmonds School Board President Deborah Kilgore; Edmonds School Board Member Carin Chase; and Shoreline School Board President Meghan Jernigan. </span></p>
      <p><b>7:20  Adoption of Agenda and the Rules, M/S/C, Adopted</b></p>
      <p><b>7:22  Overview of Election Process, explained by Chair Moralez and Raphael Baltuth, 32nd LD Technology</b></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>7:28  </b></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Election of 32nd LD Chair</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>Chris Roberts, nominated by Alan Charnley, seconded and accepts<br />
        </span><b>M/S/C, elected by acclamation</b></p>
      <p><b>7:35  </b><span style={{
          "fontWeight": "400"
        }}>Chris Roberts takes over as Chair </span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>7:36  </b></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Election of 32nd LD 1st Vice-Chair (Snohomish County)</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>Jenna Nand, nominated by Marylou Eckart, seconded and accepts<br />
        </span><b>M/S/C, elected by acclamation</b></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>7:40  </b></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Election of 32nd LD 2nd Vice-Chair (King County)</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>Lillian Hawkins, nominated by Carin Chase, seconded and accepts<br />
        </span><b>M/S/C, elected by acclamation</b></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>7:45  </b><span style={{
            "fontWeight": "400"
          }}>Election of King County Democrats Central Committee Representative</span></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}> </span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>Dean Fournier, nominated by Janet Way, seconded and accepts<br />
        </span><b>M/S/C, elected by acclamation</b></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>7:53  </b></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Election of King County Democrats Central Committee Alternate </span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>Carolyn Ahlgreen, nominated by Janet Way, seconded and accepts<br />
        </span><b>M/S/C, elected by acclamation</b></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>7:56  </b></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Election of Snohomish County Democrats Central Committee Representatives </span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>• Robert Petersen (he, him pronouns), nominated by Gray Petersen, seconded and accepts<br />
        </span><span style={{
          "fontWeight": "400"
        }}>• Marilyn Hannan (she, her pronouns), nominated by Liz Brown, seconded and accepts<br />
        </span><span style={{
          "fontWeight": "400"
        }}>• Rosamaria Graziani (she, her pronouns), nominated by Jenna Nand, seconded and accepts<br />
        </span><span style={{
          "fontWeight": "400"
        }}>• Colin Cole (he, him pronouns), nominated by Colin Cole, seconded and accepts<br />
        </span><span style={{
          "fontWeight": "400"
        }}>• Ted Hikel (he, him pronouns), nominated by Janet Way, seconded and accepts</span></p>
      <p><b>M/S/C - rule waived<br />
        </b><span style={{
          "fontWeight": "400"
        }}>The rule that candidates (Petersen and Graziani) must be PCOs is waived, unanimously.</span></p>
      <p><b>M/S/C, Elected by ballot <br />
        </b><span style={{
          "fontWeight": "400"
        }}>Rosamaria Graziani<br />
        </span><span style={{
          "fontWeight": "400"
        }}>Robert Petersen</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>9:03  </b></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Election of Snohomish County Democrats Central Committee Alternates </span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>• Colin Cole (he, him pronouns), nominated by Adrienne Fraley-Monillas, seconded and accepts <br />
        </span><span style={{
          "fontWeight": "400"
        }}>• Lael White (she, her pronouns), nominated by Tom White, seconded and accepts<br />
        </span><span style={{
          "fontWeight": "400"
        }}>• Marilyn Hannan (she, her pronouns), nominated by Gray Petersen, seconded and accepts</span></p>
      <p><b>M/S/C, elected by acclamation<br />
        </b><span style={{
          "fontWeight": "400"
        }}>Colin Cole</span></p>
      <p><b>M/S/C, Elected by ballot<br />
        </b><span style={{
          "fontWeight": "400"
        }}>Lael White</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>9:15  </b></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Election of WA State Democrats Central Committee Member</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>Alan Charnley, nominated by Jenna Nand, seconded and accepts<br />
        </span><span style={{
          "fontWeight": "400"
        }}>Carin Chase</span><b>, </b><span style={{
          "fontWeight": "400"
        }}>nominated by Gray Petersen, seconded and accepts </span></p>
      <p><b>M/S/C, elected by acclamation<br />
        </b><span style={{
          "fontWeight": "400"
        }}>Alan Charnley</span></p>
      <p><b>M/S/C, elected by acclamation<br />
        </b><span style={{
          "fontWeight": "400"
        }}>Carin Chase</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>9:18  </b><span style={{
            "fontWeight": "400"
          }}>Election of 32nd LD Treasurer<br />
          </span></span><span style={{
          "fontWeight": "400"
        }}>Eric Valpey, nominated by Carin Chase, seconded and accepts<br />
        </span><b>M/S/C, elected by acclamation</b></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>9:20  </b></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Election of 32nd LD Secretary</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>Sally Soriano, nominated by Carin Chase, seconded and accepts<br />
        </span><b>M/S/C, elected by acclamation</b></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><b>9:23  </b></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Ratification of Appointed Officers, Need Membership Approval</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>Lael White, recommended by Chair, Chris Roberts, to be Membership Chair<br />
        </span><b>M/S/C, elected by acclamation </b></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Other Appointed Officer Positions in the Bylaws are:</span> <br />
        </span><span style={{
          "fontWeight": "400"
        }}>Bylaws and Rules, Communications, Community Service, Correspondence, District Campaigns, Diversity and Inclusion, Endorsement Committee, Environmental Caucus, Fundraising, Homeless Issues Caucus, Labor Liaison, Legislative Action, Parliamentarian, Programs Coordinator, Resolutions, Seniors Issues Advocate, Sergeant at Arms, Technology, Young Democrats.</span></p>
      <p><span style={{
          "fontWeight": "400"
        }}>If you would like to be appointed to one of these positions or know someone who would be really good serving in one of these positions, please contact the chair or someone on the executive board.</span></p>
      <p> </p>
      <p><b>9:27  </b><b>New Business</b><b> <br />
        </b><b>Proposed Bylaw Changes <br />
        </b>1. Changes in the timing when dues are paid, Sec. 3.4. If you have been a member the previous year, you are eligible to vote immediately upon paying your dues.<br />
2. On the Executive Committee, District Campaign Chair will no longer be voting member; Endorsement Chair will now become a voting member.<br />
3. Specifies which version of Roberts Rules of Order the Membership body will use because the bylaws currently do not cover this amendment.</p>
      <p><b><span style={{
            "textDecoration": "underline"
          }}>Liz Brown:</span> I make a motion to approve the bylaw changes, Seconded.</b></p>
      <p><span style={{
          "fontWeight": "400"
        }}><strong><span style={{
              "textDecoration": "underline"
            }}>Marylou Eckart: </span>Speaking against the motion, I want to remove the change in Section 3.4  and amend. Seconded.</strong><br />
        </span><span style={{
          "fontWeight": "400"
        }}>I want to keep the dues to be paid by the membership within one calendar year. In my experience, I found it hard for people to remember when they paid their dues. By keeping </span><i><span style={{
            "fontWeight": "400"
          }}>January</span></i><span style={{
          "fontWeight": "400"
        }}> as the month when all dues are to be paid, it will be easier to both remind everyone, and for everyone to easily remember, that they have paid their dues for the year. </span></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Derek Fike: </span>Speaking against the motion. <br />
        </span><span style={{
          "fontWeight": "400"
        }}>As a new person who got involved in the 32nd recently, my membership paid in August would then actually be good for zero meetings. I thought I was signing up to pay for 365 days from August to August.</span></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Janet Way: </span>Speaking for the amendment. <br />
        </span><span style={{
          "fontWeight": "400"
        }}>Marylou was Membership Chair for years and has vast experience with what would be the easiest and most efficient timeline for people to pay their dues. I would, however, be interested in hearing someone comment on what Derek just said and how new people in the middle of the year, might be able to pay only partial dues for the remaining months of the year.</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Eric Valpey, Treasurer: </span></span><span style={{
          "fontWeight": "400"
        }}>Quick discussion</span><span style={{
          "fontWeight": "400"
        }}>    <br />
        </span><span style={{
          "fontWeight": "400"
        }}>Currently we do operate on somewhat of an annual basis. Anytime you pay during the year, we make your voting window a 13-month period of time. The way we do this is that we look at folks who have paid dues in the last calendar year. </span></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Marylou Eckart:</span> Point of information<br />
        </span><span style={{
          "fontWeight": "400"
        }}>If you have an issue about your dues, you can always talk with the Membership Chair about correcting the problem.</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Dean Fourier: </span></span><span style={{
          "fontWeight": "400"
        }}>Question</span><span style={{
          "fontWeight": "400"
        }}><br />
        </span><span style={{
          "fontWeight": "400"
        }}>At one time we changed our bylaws to include members who were too young to vote. I don't see that provision here. Did it get left out?</span></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Chris Roberts, Chair:</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>We'll have to check into that.</span></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Chris Roberts, Chair:</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>If you want to keep the words "shall cover a calendar year and" vote "yes"; if you are not in favor, vote "no".</span></p>
      <p><b>M/S/C - a majority voted to keep the words, "shall cover a calendar year"; 19 yes; 10 no; amendment passes</b></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Chris Roberts, Chair:</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>Any further discussion about the amended bylaws as proposed?</span></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Lael White and Dean Fournier:</span><br />
        </span><span style={{
          "fontWeight": "400"
        }}>The sentence needs two commas: Shall cover a calendar year, be set by the membership,</span></p>
      <p><b>M/S/C - Bylaw amendments as amended, are adopted, unanimously</b><b>  </b></p>
      <p><b>   </b></p>
      <ol start="2">
        <li><b> 32nd LD Representative Nomination<br />
          </b><span style={{
            "textDecoration": "underline"
          }}>Chris Roberts, Chair:</span><br />
Over the summer, 32nd LD PCOs nominated Shirley Sutton for State Representative, Position 1. We now need to nominate the winner of the election, State Representative, Cindy Ryu. </li>
      </ol>
      <p><b><span style={{
            "textDecoration": "underline"
          }}>Carol McMahon</span>: I make a motion that we nominate Cindy Ryu. Seconded.</b></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Question, Michael Brunson</span></span><span style={{
          "fontWeight": "400"
        }}>: What are we trying to do here, re-write history?</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Chris Roberts, Chair</span></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>:</span> This is not about endorsements. It is about nominations. Under the State Constitution, if a position is vacated and the person holding that position was nominated by the LD, then the LD can send three names to the County Councils, from which they will choose to fill the vacancy.</span></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Julie Anne Kempf:</span> </span><span style={{
          "fontWeight": "400"
        }}>In this process, Democrats nominate Democratic Party candidates. Prior to the top-two primary, it was a more obvious process. We are retaining the right to nominate Democrats.</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Chris Roberts, Chair: Speakers for and against:</span></span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Carol McMahon: </span></span><span style={{
          "fontWeight": "400"
        }}>For all the reason you have identified, I think we should vote "yes".</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>David Crow</span></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>:</span> I would like to speak against this. Cindy Ryu, in Shoreline, has always not represented working class interests but and has always represented the business class. Once again, here's yet another example of how the Democratic Party discusses minutia and when it should be discussing the eviction crisis, rent crisis and the financial crisis which is destroying lives. This seems totally arcane. </span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Ted Hikel</span></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>:</span> This is to protect the 32nd LD organization to allow us to send names if there is a vacancy in the position. This has nothing to do whether we are friends or not or are neutral about the nominee. It has to do with protecting our rights as an LD to control the names going forward.</span></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Chris Roberts, Chair: This is a PCO only vote.</span></span></p>
      <p><b>M/S/C - vote passes by 24 votes "yes" and 2 votes "no"</b></p>
      <p><b>  </b></p>
      <ol start="3">
        <li><b> PCO Appointments <br />
          </b><span style={{
            "textDecoration": "underline"
          }}>• Chris, Chair:</span> We have an application for a PCO appointment for Megan Atkins, LYNNWOOD 34 (Meadowdale).</li>
      </ol>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Ted Hikel:</span> </span><span style={{
          "fontWeight": "400"
        }}>It is my understanding that LYNNWOOD 34 is in the 21st LD.</span></p>
      <p><b><span style={{
            "textDecoration": "underline"
          }}>Carol McMahon</span>: I move that no matter whether Megan is in the 32nd LD or 21st LD I would like to make a motion for a vote of confidence, Seconded</b><b>.<br />
        </b><span style={{
          "textDecoration": "underline"
        }}><b>Carin Chase:</b></span> <b>I amend the motion:</b> <b>Megan is an Associate Member of the 32nd LD</b><b>.<br />
        </b><b>M/S/C - vote passes by 30 "yes"  - 1 "abstention"  - 0 "no" </b></p>
      <p><b>• Jerry Cronk</b><span style={{
          "fontWeight": "400"
        }}>, application for an Acting PCO appointment for SHL 1101 <br />
        </span><b>M/S/C - vote passes by 32 "yes" votes</b></p>
      <p><b>• Annette Ademasu</b><span style={{
          "fontWeight": "400"
        }}>, 32nd LD will vote on this Acting PCO appointment in our January meeting.</span></p>
      <p> </p>
      <p><b>10:00 Good-of-the-Order</b><b><br />
        </b><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Robert Petersen: </span></span><span style={{
          "fontWeight": "400"
        }}>I want to thank the body for their confidence in me and thank my opponents that ran a good clean race. </span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Eric Valpey</span></span><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>:</span> What would be most helpful to the 32nd Treasury would be for you to follow this link in the chat and contribute monthly -- $5-10 bucks a month. It will make a big difference when we need to do mailers and printing in election season!</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Jenna Nand:</span></span><span style={{
          "fontWeight": "400"
        }}> I wanted to thank everyone who supported me to become 1st Vice-Chair. And I also want to bring up the issue of racism that was talked about at our last meeting. I want to make sure that as an organization, we are not just talking the talk but we are actually walking the walk. So if you ever feel this is an issue, if you feel discriminated against, or have been made to feel uncomfortable, my door is always open, please contact me (jenna.nand@32democrats.org). Our e-board will be taking addressing these issues very seriously.</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Gray Petersen:</span></span><span style={{
          "fontWeight": "400"
        }}> We have a Reorg meeting in Snohomish County this weekend and I am running for Snohomish County Chair. I would appreciate your support!</span></p>
      <p><span style={{
          "fontWeight": "400"
        }}><span style={{
            "textDecoration": "underline"
          }}>Michael Brunson</span>:</span><span style={{
          "fontWeight": "400"
        }}> I am hoping the Zoom calls will be clearly advertised on our 32nd LD website and will also clearly state the telephone number as well as the computer link. These are public meetings and we want everyone to feel welcome. If you want to get the call-in number, contact the public library reference librarian at: 800-462-9600. When the 32nd LD is just emailing the meeting information to people, it looks like it is an invitation only meeting.<br />
        </span><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Chris, Chair, response:</span></span><span style={{
          "fontWeight": "400"
        }}> Thank you Michael for raising this important issue. I will talk with the Exec. Board about how we send out notifications --- we definitely want to make these meetings available to everyone. Zoom is a valuable tool and I think we will be using it into the future.</span><span style={{
          "fontWeight": "400"
        }}> </span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Lael White: </span></span><span style={{
          "fontWeight": "400"
        }}>I want to thank everyone for their support, and I especially want to thank Julie Ann Kempf from the 46th for hanging here with us for so long tonight as our parliamentarian.</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Raphael Baltuth: </span></span><span style={{
          "fontWeight": "400"
        }}>I want to second what Michael Brunson said because I was initially locked out of this meeting due to trying to access it through a web browser. I believe that we should not require the use proprietary software to access these meetings.</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Alan Charnley: </span></span><span style={{
          "fontWeight": "400"
        }}>Thank you for your support. Please think about donating to our 32nd LD so we can buy our own Zoom account and not have to rely on other Democratic Party organizations for their Zoom accounts. I look forward to working with all of you and if you want to talk to me about state issues, feel free to email me (alan.charnley@32democrats.org).</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Carin Chase: </span></span><span style={{
          "fontWeight": "400"
        }}>Thank you for sticking with this meeting so long tonight and thanks for your confidence in re-electing. I'd also like to bring it to your attention that tomorrow is Human Right's Day and there is an excellent video by Michelle Bachelet, UN High Commissioner of Human Rights (2 minutes): https://www.youtube.com/watch?v=7nY2NrJLIlk </span></p>
      <p><span style={{
          "fontWeight": "400"
        }}>I think the 32nd has done a good job on issues of human rights, as have other districts. I also want to share that a longtime member of the 32nd, prior to redistricting, John Foy, has passed on. We will be doing a celebration of his life, so if you have pictures or memories you would like to share, please contact me (carinchase@gmail.com) or Maralyn Chase (maralynchase@gmail.com)</span></p>
      <p><span style={{
          "textDecoration": "underline"
        }}><span style={{
            "fontWeight": "400"
          }}>Jeanne Monger:</span></span><span style={{
          "fontWeight": "400"
        }}> I just wanted to say thank you Alan for doing such a great job as Chair! And thank you Chris for stepping now and for all the other officers who have stepped up as well.</span></p>
      <p> </p>
      <p><b>10:30  Chris Roberts, Chair: Without objection, we are adjourned.</b></p>
      <p><b>Next Meeting, Wednesday, January 13, 2021 </b></p>
      <p> </p>
      <p>Respectfully submitted,<br />
        <i>Sally Soriano,</i> 32nd LD Secretary<b><br />
        </b><span style={{
          "fontWeight": "400"
        }}>sally.soriano@32democrats.org</span></p>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      